<mat-card>
  <mat-card-title>{{ title }}</mat-card-title>
  <mat-card-content>
    <mat-list>
      <mat-list-item *ngFor="let item of expenses.items; last as last">
        <div matLine fxLayout="row" fxLayoutAlign="start center">
          <mat-icon class="header-icon">{{ item.icon }}</mat-icon>
          &nbsp;&nbsp;
          <p fxFlex>{{ item.label }}</p>
          <p>{{ item.total / npax | number: "1.2-2" }} €</p>
        </div>
        <mat-divider *ngIf="!last"></mat-divider>
      </mat-list-item>
    </mat-list>
  </mat-card-content>
  <mat-card-title
    >{{ expenses.total / npax | number: "1.2-2" }} €</mat-card-title
  >
  <mat-card-subtitle><i>prezzo totale a persona</i></mat-card-subtitle>
</mat-card>
